import React from "react";
import { NavLink } from "react-router-dom";
import wave from "../../assets/img/home/wave.svg";
import hands from "../../assets/icons/hands.svg";
import maps from "../../assets/img/home/map.svg";
import mapsMobile from "../../assets/img/home/map-mobile.svg";
import sunset from "../../assets/img/home/sunset.png";

export default function HomeGetInspired() {
  const show = false;

  const news = [
    {
      img: require("../../assets/img/home/team.jpg"),
      title: "lorem ipsum imdor sit",
      descrition: "lorem ipsum imdor",
    },
    {
      img: require("../../assets/img/home/inspiring.jpg"),
      title: "lorem ipsum imdor sit",
      descrition: "lorem ipsum imdor",
    },
    {
      img: require("../../assets/img/home/umbrella.jpg"),
      title: "lorem ipsum imdor sit",
      descrition: "lorem ipsum imdor",
    },
    {
      img: require("../../assets/img/home/friends.jpg"),
      title: "lorem ipsum imdor sit",
      descrition: "lorem ipsum imdor",
    },
    {
      img: require("../../assets/img/home/working.jpg"),
      title: "lorem ipsum imdor sit",
      descrition: "lorem ipsum imdor",
    },
    {
      img: require("../../assets/img/home/travel.jpg"),
      title: "lorem ipsum imdor sit",
      descrition: "lorem ipsum imdor",
    },
  ];
  return (
    <>
      <div>
        <div className="relative bg-dark-denim">
          <figure className="relative hidden lg:flex justify-end container mx-auto pt-8 -mb-10">
            <img
              src={require("../../assets/img/home/rokect.png")}
              alt=""
              className="hidden lg:block absolute -top-16 right-24 w-1/3 rotate-[1deg] mt-12 2xl:mt-8"
            />
          </figure>
          <img src={wave} alt="" className="w-full lg:mt-4" />
        </div>
        <div className="container mx-auto bg-grey xl:-mt-20 pb-24 md:pb-28">
          <div className="md:-translate-y-8 px-4 lg:px-0 md:mb-4 grid grid-cols-3 md:grid-cols-5 items-end gap-6 xl:-mt-24">
            <img
              src={sunset}
              alt="sunset"
              className="z-10 -mt-52 mb-9 md:mb-20 rounded mx-auto col-span-3 md:col-span-2"
            />
            <div className="col-span-3 md:col-span-3 max-w-3xl">
              <p className="mb-16 -mt-2 xl:mt-6 md:mb-16 xl:mb-10 tracking-[-0.018em] lg:tracking-normal">
                We have the vision to create a heritage sector that is more
                self-reliant and sustainable in its operations and can meet its
                needs in a rapidly changing world without being solely reliant
                on government support to achieve its mandates. We believe in the
                importance of preserving and promoting natural and cultural
                heritage, and strong organizations are better equipped to do
                this.
              </p>
              <NavLink
                to="/mission-and-values"
                className="shadow-lg mx-auto lg:mx-0 h-12 w-64 mb-20 xl:mb-36 bg-navy-blue rounded-full hover:bg-dark-denim text-white grid place-items-center with-transition"
              >
                our guiding force
              </NavLink>
            </div>
          </div>
          <article className="mx-4 xl:mx-0 overflow-hidden lg:flex lg:justify-center bg-navy-blue rounded-3xl text-white shadow-lg">
            <img
              src={hands}
              alt="forager gives back"
              className="w-full object-bottom"
            />
            <div className="pl-9 pr-8 pb-14 md:py-14 md:pl-16 md:pr-24">
              <h5 className="mt-3 md:mt-0 mb-7 text-2xl font-medium">
                forager gives back
              </h5>
              <p className="mb-5">
                Our mandate is to provide support and community development
                opportunities within the areas that we work. That is why Forager
                International and all businesses under its umbrella is proud to
                dedicate at least 1% of all revenue to charitable causes in each
                community where we operate.
              </p>
              <p>
                To find out more about this program or how to apply for funding,
                <NavLink to="/contact">
                  <strong className="font-bold"> please contact us.</strong>
                </NavLink>
              </p>
            </div>
          </article>
        </div>
      </div>
      <div className="px-4 pt-20 md:pt-32 pb-24 md:pb-36 bg-cards-home bg-cover bg-no-repeat">
        <div className="container mx-auto">
          <h2 className="lg:w-2/3 text-center mx-auto text-4xl lg:text-6xl with-line-above line-above-center before:w-40 text-white pt-2 pb-16 md:pb-16">
            exciting updates from across our network
          </h2>
          {show ? (
            <>
              <section className="grid grid-cols-3 gap-5 xl:gap-6 pb-16 md:pb-16">
                {news.map((e, i) => (
                  <div
                    className="card card-compact col-span-3 md:col-span-1 bg-white shadow-xl"
                    key={i}
                  >
                    <figure>
                      <img src={e.img} alt="team" />
                    </figure>
                    <div className="pt-6 pb-7 px-7 rounded-b-xl">
                      <h2 className="font-medium text-2xl text-navy-blue with-line-above before:w-24 before:border-navy-blue line-above-start">
                        {e.title}
                      </h2>
                      <span> {e.descrition} </span>
                    </div>
                  </div>
                ))}
              </section>
              <NavLink
                to="//working-at-forager"
                className="w-48 h-12 mx-auto grid place-items-center bg-white font-medium rounded-[50px]"
              >
                see more
              </NavLink>
            </>
          ) : (
            <p className="text-2xl lg:text-4xl py-10 text-center font-medium text-white">
              Important news coming soon!
            </p>
          )}
        </div>
      </div>
      <div className="container mx-auto">
        <div className="px-4 lg:px-0 py-20 md:py-28 grid md:grid-cols-2 bg-grey">
          <h2 className="text-4xl lg:text-6xl text-navy-blue text-center md:text-start md:order-1 with-line-above before:w-40 lg:mb-7 before:border-navy-blue line-above-center md:line-above-start">
            our global reach
          </h2>
          <figure className="mt-8 mb-16 md:my-auto md:ml-6 md:order-2 md:row-span-4">
            <img
              src={mapsMobile}
              alt="forager our global reach"
              className="block md:hidden mx-auto"
            />
            <img
              src={maps}
              alt="forager our global reach"
              className="hidden md:block w-full max-w-[38rem] mx-auto"
            />
          </figure>
          <div className="md:order-3 text-black">
            <p className="md:pt-3">
              We partner with organizations around the world to provide support
              to projects, build capacity, and search for funding. Whether our
              businesses work with small local organizations or national
              institutions, the approach always values professional-quality with
              a personal touch. We are all stronger by working together. If we
              are talking about the Forager International business network or
              the Forager Partnership Network, the sentiment is the same.
            </p>
            <p className="mt-11 lg:mt-7 text-2xl text-center md:text-start text-navy-blue font-medium">
              global hq
            </p>
            <span className="mt-3 mb-1 block text-center md:text-start lg:mb-3">
              Cork, Ireland
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
